import type { PropsWithChildren } from "react";
import { useSession } from "../auth/sessionContext";
import { InlineNotice } from "../components/Feedback/InlineNotice";
import { hasCommerceAdminAccess } from "./commerceAccess";
import styles from "./CommerceRouteGuard.module.css";

export function CommerceRouteGuard({ children }: PropsWithChildren) {
  const session = useSession();
  if (!hasCommerceAdminAccess(session)) {
    return (
      <section className={styles.denied} data-status-code="403" aria-label="Commerce unavailable">
        <InlineNotice tone="error" title="Commerce unavailable">
          {session.user.role === "staff"
            ? "Commerce administration is available to workspace owners and managers."
            : session.user.role === "super_admin" && !session.featureTenantId
              ? "Select a tenant before opening Commerce administration."
              : "Commerce is not enabled for this workspace."}
        </InlineNotice>
      </section>
    );
  }
  return children;
}
